export class Complemento {
    idOrdenServicio: number;
    idValuacionDetalle: number;
    tipo: string;
    cantidad: number;
    descripcion: string;
    cotizacion: number;
    precioUnitario: number;
    manoObra: number;
    surteSeguro: boolean;
    proveedor: string;
    autorizadoRefacciones: number;
    autorizadoManoObra: number;
    costoRefacciones: number;
    costoManoObra: number;
    idTipoPlanTrabajo: number;
    idEmpleado: number;
    idProveedor: number;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/complemento.ts